import { Container, Svg, Text } from "@mike/crt";
import arrowDownIcon from "../../../assets/icons/arrow-down.svg";
import arrowUpIcon from "../../../assets/icons/arrow-up.svg";

export function SceneFooter() {
  return (
    <Container
      alignItems="center"
      justifyContent="center"
      flexDirection="row"
      width="100%"
      gap={60}
    >
      {/* Move instructions */}
      <Container flexDirection="row" alignItems="center" gap={12}>
        <Container flexDirection="row" alignItems="center" gap={3}>
          <Svg src={arrowUpIcon} width={18} height={18} color="#6ab0d8" />
          <Svg src={arrowDownIcon} width={18} height={18} color="#6ab0d8" />
        </Container>
        <Text fontSize={14} color="rgba(100, 160, 200, 0.4)">
          or
        </Text>
        <Text fontSize={14} color="#6ab0d8">
          W/S
        </Text>
        <Text fontSize={14} color="rgba(100, 160, 200, 0.4)">
          MOVE
        </Text>
      </Container>

      {/* Select instructions */}
      <Container flexDirection="row" alignItems="center" gap={12}>
        <Text fontSize={14} color="#6ab0d8">
          ENTER
        </Text>
        <Text fontSize={14} color="rgba(100, 160, 200, 0.4)">
          SELECT
        </Text>
      </Container>

      {/* Back instructions */}
      <Container flexDirection="row" alignItems="center" gap={12}>
        <Text fontSize={14} color="#6ab0d8">
          ESC
        </Text>
        <Text fontSize={14} color="rgba(100, 160, 200, 0.4)">
          BACK
        </Text>
      </Container>
    </Container>
  );
}
